export default __webpack_public_path__ + "static/media/agen_referral.ec61cdae.svg";